import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { getDeepFromObject, NbAuthResult, NbAuthService, NB_AUTH_OPTIONS } from '@nebular/auth';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { RolesData } from '../../../@core/interfaces/common/roles';

@Component({
  selector: 'ngx-reset-password-inside-app',
  templateUrl: './reset-password-inside-app.component.html',
  styleUrls: ['./reset-password-inside-app.component.scss']
})
export class ResetPasswordInsideAppComponent implements OnInit {
  resetPasswordForm: FormGroup;
  minLength: number = 8;
  maxLength: number = this.getConfigValue('forms.validation.password.maxLength');
  redirectDelay: number = this.getConfigValue('forms.resetPassword.redirectDelay');
  showMessages: any = this.getConfigValue('forms.resetPassword.showMessages');
  strategy: string = this.getConfigValue('forms.resetPassword.strategy');
  isPasswordRequired: boolean = this.getConfigValue('forms.validation.password.required');
  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  isPwdUpdated: boolean =false;
  isNum: boolean=false;
  isSC: boolean=false;
  isLC: boolean=false;
  isUC: boolean=false;
  isLength: boolean = false;
  get apiUrl(): string {
    return environment.apiUrl;
  }
  protected readonly unsubscribe$ = new Subject<void>();
  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  private userId = localStorage.getItem("userId");
  constructor(protected service: NbAuthService,@Inject(NB_AUTH_OPTIONS) protected options = {},
  protected cd: ChangeDetectorRef,
  protected fb: FormBuilder,
  protected rolesService: RolesData,
  protected router: Router) {
    
   }

  ngOnInit(): void {
    const passwordValidators = [
      Validators.minLength(this.minLength),
      Validators.maxLength(this.maxLength),
      Validators.required,
      Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~])(?=.{8,})/)
    ];
    this.resetPasswordForm = this.fb.group({
      newpassword: this.fb.control('', [...passwordValidators]),
      confirmPassword: this.fb.control('', [...passwordValidators]),
      oldPassword: this.fb.control('', [Validators.required]),
    });
  }
  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
  get resetfval(): { [key: string]: AbstractControl } { return this.resetPasswordForm.controls; }
  get newpassword() { return this.resetPasswordForm.get('newpassword'); }
  get confirmPassword() { return this.resetPasswordForm.get('confirmPassword'); }
  get oldPassword() { return this.resetPasswordForm.get('oldPassword'); }

  changePwd(){
    this.errors=[];
    this.submitted = true;
    if(this.resetPasswordForm.valid)
    {
    let pwdCheckData = {
      oldPassword: this.resetPasswordForm.get('oldPassword').value,
      password: this.resetPasswordForm.get('newpassword').value,
      confirmPassword: this.resetPasswordForm.get('confirmPassword').value,
      tenantId: this.tenantId
    }
    this.rolesService.create(`${this.apiUrl}/auth/vaidate-and-reset-password`, pwdCheckData).pipe(takeUntil(this.unsubscribe$)).subscribe((result: any) => {
      console.log("result.......",result);
      this.submitted =false;
      if (result.succeeded) {
       // this.messages = result.getMessages();
        this.isPwdUpdated = true;
        setTimeout(() => {
          this.isPwdUpdated = false;
          this.router.navigate(['/auth/logout']);

        }, 4000);
      }
      else {
        if(result.message == 'Wrong Password')
        this.errors.push("Old Password is incorrect!");
        else
        this.errors.push("Something went wroung!");
      }
      this.cd.detectChanges();
    }, (error) => {
      console.log("error.......",error);
      this.submitted =false;
      if(error.error.message == 'Wrong Password')
      this.errors.push("Old Password is incorrect!");
      else
      this.errors.push("Something went wroung!");
    }, () => {
    });
  }
  }
   containsSpecialChars(str) {
    const specialChars = `\`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`;
  
    const result = specialChars.split('').some(specialChar => {
      if (str.includes(specialChar)) {
        return true;
      }
  
      return false;
    });
  
    return result;
  }
  containsNumbers(str) {
    const numbers = '1234567890';
    const result = numbers.split('').some(specialChar => {
      if (str.includes(specialChar)) {
        return true;
      }
  
      return false;
    });
  
    return result;
  }
  containsLC(str) {
  
    return str.toUpperCase() != str;
  }
  containsUC(str) {
  
    return str.toLowerCase() != str;
  }
  checkPwdStrength(event)
  {
    let word = event.target.value;
    if( word.length >= 8)
    this.isLength = true;
    else
    this.isLength = false;

  if(/\d/.test(word))
  this.isNum = true;
  else
  this.isNum = false;

  if(this.containsSpecialChars(word))
  this.isSC = true;
  else
  this.isSC = false;

  if(this.containsLC(word))
  this.isLC = true;
  else
  this.isLC = false;
  if(this.containsUC(word))
   this.isUC = true;
   else
  this.isUC = false;
  }
   cancel()
  {

  }
}
